import { PayloadAction } from "@reduxjs/toolkit";

import { ApplicationState, TRouteCalculationLoadingStatus } from "../../types";

export const setRouteCalculationLoadingStatus = (
  state: ApplicationState,
  action: PayloadAction<TRouteCalculationLoadingStatus>
) => {
  state.routeCalculationLoadingStatus = action.payload;
};
